import React,{useState, Suspense, useEffect} from "react";
import ReactDOM from 'react-dom';
import DataAdapter from "../../adapter/DataAdapter";
import Dialog from "../../component/Dialog";

import { Card, CardBody, CardHeader, CardImg, CardLink, CardText, CardTitle, Col, Input, ListGroup, ListGroupItem, Row, Modal, ModalBody, ModalFooter, ModalHeader, Button, FormGroup, Label} from 'reactstrap';
import MessageUtil from "../../lib/MessageUtil";

class Task {
    constructor(){

    }
    selectById = async (_id) =>{
        const _query    =   "select * from rb_project_tasks where pt_id = " + _id;
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }
    selectByParent = async (_id, _type) =>{		
        //const _query    =   "select pt.pt_id as `Id`, pt.prj_id as `prj_id-`, pt.task as `Task`, pt.task_description as `task_description-`, pt.task_status as `task_status-`, ty.rb_type_desc as `Type`, pt.sender_id as `sender_id-`, pt.receiver_id as `receiver_id-`, pt.estimate_cost AS `Est. Cost`, sum(ptd.real_cost) AS `Rl. Cost`, pt.task_weight as `Weight` from rb_project_tasks pt left join rb_project_task_details ptd on ptd.pt_id = pt.pt_id inner join rb_types ty on (ty.rb_type_no=pt.task_type and ty.rb_type='task_type') where pt.parent = " + _id + " group by pt.pt_id;";
        const _query    =   "select pt.* from rb_project_tasks pt where pt.parent = " + _id + " ;";
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }
    selectByTaskType = async (_prj_id, _task_type) =>{		
        const _query    =   "select pt.pt_id as `Id`, rnp.amount AS `Rl. Cost+`, rnp.rp_cat, rnp.rp_date, rnp.rp_desc, rnp.bank_id, rnp.person_id, rnp.is_done, rnp.image_id from rb_project_tasks pt left join rb_receive_n_payments rnp on rnp.pt_id = pt.pt_id inner join rb_types ty on (ty.rb_type_no=pt.task_type and ty.rb_type='task_type') where pt.prj_id >= " + _prj_id + " AND pt.task_type " + _task_type ;
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }
    selectByTaskTypeGroup = async (_prj_id, _task_type) =>{		
        const _query    =   "select pt.pt_id as `Id`, pt.prj_id as `prj_id`, pt.task_type AS `TypeId`, pt.task as `Task`, pt.task_description as `task_description`, pt.task_status as `task_status`, ty.rb_type_desc as `Type`, pt.sender_id as `sender_id`, pt.receiver_id as `receiver_id`, pt.estimate_cost AS `Est. Cost`, sum(rnp.amount) AS `Rl. Cost`, pt.task_weight as `Weight` from rb_project_tasks pt left join rb_receive_n_payments rnp on rnp.pt_id = pt.pt_id inner join rb_types ty on (ty.rb_type_no=pt.task_type and ty.rb_type='task_type') where pt.prj_id = " + _prj_id + " AND pt.task_type " + _task_type + " group by pt.pt_id;";
        //const _query    =   "select pt.pt_id as `Id`, pt.prj_id as `prj_id-`, pt.task as `Task`, pt.task_description as `task_description-`, pt.task_status as `task_status-`, ty.rb_type_desc as `Type`, pt.sender_id as `sender_id-`, pt.receiver_id as `receiver_id-`, pt.estimate_cost AS `Est. Cost+`, rnp.amount AS `Rl. Cost+`, rnp.rp_cat, rnp.rp_date, rnp.rp_desc, rnp.bank_id, rnp.person_id, rnp.is_done, pt.task_weight as `Weight` from rb_project_tasks pt left join rb_receive_n_payments rnp on rnp.pt_id = pt.pt_id inner join rb_types ty on (ty.rb_type_no=pt.task_type and ty.rb_type='task_type') where pt.prj_id >= " + _prj_id + " AND pt.task_type " + _task_type ;
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }
    viewById = async (_id) =>{
        const _query    =   "select prj_id,pt_id, ty.rb_type_desc as task_type, task, task_description, tyy.rb_type_desc as task_status, sender_id, receiver_id, CONCAT(pr.name, ' ', pr.lastname) AS receiver_name, pr.email AS receiver_email, note from rb_project_tasks pt inner join rb_types ty on (ty.rb_type_no=pt.task_type and ty.rb_type = 'task_type') inner join rb_types  tyy on (tyy.rb_type_no=pt.task_status and tyy.rb_type='task_status') inner join rb_person pr ON pr.person_id=pt.receiver_id where pt_id = " + _id;
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }

    update = async (_id, _field, _value) =>{
        const _query    =   "UPDATE rb_project_tasks SET " + _field + " = '" + _value + "' WHERE pt_id=" + _id + ";\r\nSELECT pt.pt_id, pt.prj_id, pt.task_type, ty.rb_type_desc AS task_type_desc, pt.task_status, tyy.rb_type_desc AS task_status_desc FROM rb_project_tasks pt INNER JOIN rb_types ty ON (ty.rb_type='task_type' AND ty.rb_type_no = pt.task_type) INNER JOIN rb_types tyy ON (tyy.rb_type='task_status' AND tyy.rb_type_no = pt.task_status) WHERE pt_id = " + _id + ";";
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }

    updateLaborTimeSheet = async () =>{
        const _query    =   "CALL Update_Timesheet2();";
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }

    changeStatus = async (_id, _status) =>{
        const _query    =   "UPDATE rb_project_tasks SET task_status=" + _status + ", end_date=now() where pt_id = " + _id + ";\r\nSELECT pt.pt_id, pt.prj_id, pt.task_type, ty.rb_type_desc AS task_type_desc, pt.task_status, tyy.rb_type_desc AS task_status_desc FROM rb_project_tasks pt INNER JOIN rb_types ty ON (ty.rb_type='task_type' AND ty.rb_type_no = pt.task_type) INNER JOIN rb_types tyy ON (tyy.rb_type='task_status' AND tyy.rb_type_no = pt.task_status) WHERE pt_id = " + _id + ";";
        var dataAdapter =new DataAdapter(_query);
        var data = await dataAdapter.getRecords();
        return data;
    }
    changeType			=	async (_id, _type) =>{
        const _query    =   "UPDATE rb_project_tasks SET task_type=" + _type + " where pt_id = " + _id + ";\r\nSELECT pt.pt_id, pt.prj_id, pt.task_type, ty.rb_type_desc AS task_type_desc, pt.task_status, tyy.rb_type_desc AS task_status_desc FROM rb_project_tasks pt INNER JOIN rb_types ty ON (ty.rb_type='task_type' AND ty.rb_type_no = pt.task_type) INNER JOIN rb_types tyy ON (tyy.rb_type='task_status' AND tyy.rb_type_no = pt.task_status) WHERE pt_id = " + _id + ";";
       var dataAdapter =new DataAdapter(_query);
		var data = await dataAdapter.getRecords();
        return data;
    }
	
	openQuickTaskForm	=	async(_project)	=>{
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormQuickTask = React.lazy(() => import('./FormQuickTask'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<FormQuickTask projectId={_project} callback={(obj)=>resolve(obj)} />
				</Suspense>
			, div);					
		});
	}
	
	openAssignTask		=	async(_project)	=>{
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormAssignTask = React.lazy(() => import('./FormAssignTask'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<FormAssignTask project={_project} callback={(obj)=>{resolve(obj);}} />
				</Suspense>
			, div);		
			
		});
	
		return _return;
	}

	openScopeOfWorks	=	async(_project, _parent, _receiver)	=>{
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormScopeOfWorks = React.lazy(() => import('./FormScopeOfWorks'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<FormScopeOfWorks project={_project} parent={_parent} receiver={_receiver} callback={(obj)=>{resolve(obj);}} />
				</Suspense>
			, div);		
			
		});
	
		return _return;
	}

	openAddNote		=	async(_project)	=>{
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormAddNote = React.lazy(() => import('./FormAddNote'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<FormAddNote project={_project} callback={(obj)=>resolve(obj)} />
				</Suspense>
			, div);		
			
		});
	
		return _return;
	}
	
	openAlarm		=	async(_project)	=>{
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormAlarm = React.lazy(() => import('./FormAlarm'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<FormAlarm project={_project} callback={(obj)=>{resolve(obj);}} />
				</Suspense>
			, div);		
			
		});
	
		return _return;
	}

	openActionForm	=	async(_task_type)	=>{
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			//const ActionForm = React.lazy(() => import('../Marketing/ViewMarketing'));
			const ActionForm = (props) =>{
				const [actions, setActions] = useState([]);
				useEffect(()=>{
					var dataAdapter =new DataAdapter("SELECT * FROM rb_link WHERE id IN (SELECT rb_type_actionform FROM rb_types WHERE rb_type='task_type' AND rb_type_no=" + props.taskType + ")");
					dataAdapter.getRecords().then(data=>{
						setActions(data);
					})

				},[])
				return (
					<>
					<ListGroup flush>
						{actions.map(action=>{
							return (<>
								<ListGroupItem>
									<a href={'/#' + action.url } target="_blank" >{action.caption}</a>
								</ListGroupItem>
							</>);
						})}
					</ListGroup>
					</>
				);
			}
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<Dialog title={"Select Action Form"} isOpen={true} >
						<ActionForm taskType={_task_type} parameters={{}} callback={(obj)=>resolve(obj)}/>
					</Dialog>
				</Suspense>
			, div);		
			
		});
	
		return _return;
	}

	ViewTask		=	async (_task)	=>{
		var isProgressing = false;
		const callback	=	(response)	=>{
			isProgressing = true;
			//alert(response);
		}
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const ViewTask = React.lazy(() => import('./ViewTask'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<Dialog title={"Project " + _task.prj_id } isOpen={true} isProgressing={isProgressing} notify="" >
						<ViewTask project={_task} projectId={_task.prj_id} taskId={_task.pt_id} callback={(response)=>{callback(response);resolve(response);}} />
					</Dialog>
				</Suspense>
			, div);		
		});
	
		return _return;
	}
	viewTaskUpdateForm	= async	(_task)	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormTaskUpdate = React.lazy(() => import('./FormTaskUpdate'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<FormTaskUpdate task={_task} callback={(obj)=>resolve(obj)} />
				</Suspense>
			, div);
		});
	
		return _return;
	}	

    clockIn = async () =>{
    }
    clockOut = async (senderId, taskId) =>{
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormClockOut = React.lazy(() => import('../TaskDetails/FormClockOut'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<FormClockOut senderId={senderId} taskId={taskId} callback={(obj)=>resolve(obj)} />
				</Suspense>
			, div);
		});
	
		return _return;
    }

	ViewTaskOfPerson	= async	()	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const ViewTaskOfPerson = React.lazy(() => import('../../ViewTaskOfPerson'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<Dialog title="Active Tasks" isOpen={true} isProgressing={false} notify="" >
						<ViewTaskOfPerson status="1,2,3,4,5,6,7,8,9,10" callback={(obj)=>resolve(obj)} />
					</Dialog>
				</Suspense>
			, div);
		});
	
		return _return;
	}	
	ViewTaskOfGantt	= async	(_task)	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormGanttTask = React.lazy(() => import('./FormGanttTask'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<FormGanttTask task={_task} callback={(obj)=>resolve(obj)} />
				</Suspense>
			, div);
		});
	
		return _return;
	}
	
	ViewEstimate	= async	(_projectId)	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const ViewEstimate = React.lazy(() => import('../Estimate/ViewEstimate'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<ViewEstimate projectId={_projectId} />
				</Suspense>
			, div);
		});
	
		return _return;
	}	

	ViewScopeOfWork	= async	(_projectId)	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const ViewEstimate = React.lazy(() => import('../Estimate/ViewEstimate'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<ViewEstimate projectId={_projectId} />
				</Suspense>
			, div);
		});
	
		return _return;
	}	

	ViewInvoice	= async	(_projectId)	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const ViewInvoice = React.lazy(() => import('../Invoice/ViewInvoice'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<ViewInvoice projectId={_projectId} />
				</Suspense>
			, div);
		});
	
		return _return;
	}	

	ViewBill	= async	(_projectId)	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const ViewBillManager = React.lazy(() => import('../Accounting/ViewBillManager'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<ViewBillManager projectId={_projectId} />
				</Suspense>
			, div);
		});
	
		return _return;
	}	

	ViewBillDetail	= async	(_projectId)	=>{
		
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const ViewBillDetail = React.lazy(() => import('../Accounting/ViewBillDetail'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
						<ViewBillDetail projectId={_projectId} />
				</Suspense>
			, div);
		});
	
		return _return;
	}
	
	openLog		=	async(_type, _project)	=>{
		const _return = await new Promise((resolve, rej) => {
			const div	=	document.createElement('div');
			document.body.appendChild(div);
			const FormLog = React.lazy(() => import('./FormLog'));
			ReactDOM.render(
				<Suspense fallback={<div>Loading... </div>}>
					<FormLog type={_type} project={_project} callback={(obj)=>resolve(obj)} />
				</Suspense>
			, div);		
			
		});
	
		return _return;
	}

	notifyToReceiver	=	async(_taskId) =>{
		var _task =await this.viewById(_taskId)
		const emailBody = `
					<!doctype html>
					<html lang="en">
					<head>
					<meta charset="utf-8">
					<meta name="viewport" content="width=device-width,initial-scale=1">
					<title>New Task Assigned</title>
					</head>
					<body style="margin:0;padding:0;background-color:#f7f6f4;font-family:Arial, Helvetica, sans-serif;">
					<table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px;margin:30px auto;background:#ffffff;border-radius:8px;overflow:hidden;box-shadow:0 2px 6px rgba(0,0,0,0.08);">
						
						<!-- Title Bar -->
						<tr>
						<td style="padding:14px 24px;background:#c9a34f;text-align:center;color:#000000;">
							<h1 style="margin:0;font-size:18px;font-weight:600;">New Task Assigned</h1>
						</td>
						</tr>

						<!-- Body -->
						<tr>
						<td style="padding:24px;">
							<p style="margin:0 0 12px 0;font-size:15px;color:#222222;">Hi <strong>${_task[0].receiver_name}</strong>,</p>

							<p style="margin:0 0 16px 0;font-size:15px;color:#222222;">
							You have been assigned a new task:
							</p>

							<p style="margin:0 0 20px 0;font-size:16px;color:#000000;font-weight:700;">
								${_task[0].task_type}<br/>
								${_task[0].task}<br/>
								${_task[0].task_description}
							</p>

							<p style="margin:0 0 20px 0;text-align:center;">
							<a href="${process.env.REACT_APP_SOURCE_URL}/#/ViewProjectTask/${_task[0].prj_id}/${_task[0].pt_id}" style="display:inline-block;padding:10px 20px;text-decoration:none;border-radius:6px;background:#000000;color:#c9a34f;font-weight:600;" >
								View Task
							</a>
							</p>

							<p style="margin:0 0 10px 0;font-size:14px;color:#555555;">
							Please review the task details and start when ready. If you have any questions or need clarification, contact your manager.
							</p>

							<p style="margin:22px 0 0 0;font-size:14px;color:#555555;">
							Best regards,<br>
							<strong>Office Manager</strong><br>
							<span style="color:#777777;font-size:13px;">8CO Group</span>
							</p>
						</td>
						</tr>

						<!-- Footer -->
						<tr>
						<td style="padding:14px 24px;background:#000000;color:#c9a34f;font-size:12px;text-align:center;">
							You are receiving this because a task was assigned to you. If this is an error, please contact your administrator.
						</td>
						</tr>
					</table>
					</body>
					</html>
		`;
		(new MessageUtil()).onSendEmail("office@8cogroup.com", _task[0].receiver_email, "8CO - Task Assignment Notification", emailBody,"Office@2025!ecogroup");
		console.log(_task);
	}
	

}
export default Task;